import Lottie from 'lottie-react';
import * as PropTypes from 'prop-types';
import React from 'react';
import loadingAnim from '../../assets/lottie-animation/Spinner.json';
import HelperService from '../../services/HelperService';
import TypesService from '../../services/TypesService';
import Icon, { Icons } from '../Icon/Icon';
import './IconAML.scss';

const BlockchainsById = TypesService.BlockchainsById;

const IconAML = ({
	percent = null,
	isActualAML = true,
	blockchainName = '',
	blockchainId = null,
	showBlockchain = false,
	iconOnly = false,
	isError = false,
	isLoading = false,
	size = 40,
	checkDate = null,
}) => {
	const blockchain = blockchainName
		? Object.values(BlockchainsById).find(i => i.network === blockchainName)
		: BlockchainsById[blockchainId];

	const { risk } = HelperService.getAmlRiskByText(percent, isActualAML, blockchain?.network, isError, checkDate);
	return (
		<div className={'IconAML ' + risk} style={{ '--size': size + 'px' }}>
			{isLoading ? (
				<Lottie className='IconAML__loading' animationData={loadingAnim} />
			) : (
				<Icon
					className='IconAML-default-icon'
					type={Icons[risk === 'ErrorTriangle' ? risk : 'DefaultAML']}
					width={size}
					height={size}
				/>
			)}
			{!iconOnly &&
				(risk === 'Unchecked' && !isLoading ? (
					<div className='IconAML__percent'>
						<Icon type={Icons.QUESTIONMARK_CIRCLE_FILL} width={16} height={16} />
					</div>
				) : showBlockchain ? (
					<div className='IconAML__currency'>
						<Icon type={Icons[blockchain?.Icon]} width={20} height={20} />
					</div>
				) : (
					risk !== 'Unverified' && <div className='IconAML__percent'>{`${percent || 0}%`}</div>
				))}
		</div>
	);
};

IconAML.propTypes = {
	percent: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
	isActualAML: PropTypes.bool,
	blockchainId: PropTypes.number,
	blockchainName: PropTypes.string,
	showBlockchain: PropTypes.bool,
	iconOnly: PropTypes.bool,
	isError: PropTypes.bool,
	isLoading: PropTypes.bool,
	size: PropTypes.number,
};

export default IconAML;
